import * as React from "react";
import cx from "classnames";
import HeroBackground from "./HeroBackground";
import Section from "../../Layout/Section";
import Button from "../../UI/NewButton";
import Media from "../../Common/Media";
import TemplateString from "../../Common/TemplateString";
import * as styles from "./hero.module.css";

const Hero = ({title, description, variant, buttonText, buttonUrl, image}) => {
    return (
        <Section
            className={cx(styles.hero, {
                [styles.hero_vertical]: variant === "vertical",
            })}
        >
            <div className={styles.hero__container}>
                <div>
                    <h1 className={styles.hero__title}>
                        <TemplateString template={title} />
                    </h1>
                    <div className={styles.hero__desc}>
                        <TemplateString template={description} />
                    </div>
                    <Button isLink href={buttonUrl} className={styles.hero__button}>
                        {buttonText}
                    </Button>
                </div>
                <div className={styles.hero__mediaWrapper}>
                    <Media
                        media={{content: image}}
                        className={styles.hero__media}
                        imageProps={{
                            imgClassName: styles.hero__mediaImage,
                            passClassToSVG: true,
                        }}
                    />
                </div>
            </div>
            <div className={styles.hero__bottomGradient} />
            <HeroBackground />
        </Section>
    );
};

export default Hero;
